import {queryMediaId, config, AgentConfigUrl} from "@/server/api.js";
import {Toast} from "vant";

let corpid = process.env.NODE_ENV === 'development' ? "ww6339b91a807d09c8" : "ww29a0b9ab8da601a6";
let agentid = process.env.NODE_ENV === 'development' ? '1000005' : '1000016';

// 转换文件类型
export async function changeFileType(obj, msgType) {
    let contentObj = {};
    switch (msgType) {
        case "text":
            contentObj = {
                content: obj.content,
            };
            break;
        case "image":
        case "video":
        case "file":
            let mediaid = await getMediaId(obj.id);
            contentObj = mediaid;
            break;
        case "news":
            contentObj = {
                link: obj.url, //H5消息页面url
                title: obj.title, //H5消息标题
                desc: obj.content, //H5消息摘要
                imgUrl: obj.picUrl,
            };
            break;
        case "miniprogram":
            contentObj = {
                appid: obj.appId, //小程序的appid，企业已关联的任一个小程序
                title: obj.title, //小程序消息的title
                imgUrl: obj.url, //小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
                page: obj.linkUrl,
            };
            break;
        default:
            "";
    }
    return contentObj
}

// 获取素材id
export async function getMediaId(id) {
    const res = await queryMediaId({id: id});
    if (res.code !== "200") return Toast.fail(res.msg);
    return {mediaid: res.data};
}

export async function wxConfig(windowurl, jsApiList) {
    var flag = false
    var formdata = new FormData();
    formdata.append("url", windowurl);
    const res = await config(formdata);
    var dataObj = res.data;
    return new Promise((resolve, reject) => {
        wx.config({
            timestamp: dataObj.timestamp,
            nonceStr: dataObj.noncestr,
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: corpid, // 必填，企业微信的corpID
            signature: dataObj.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: jsApiList,
        });
        wx.ready(async function () {
            let newformdata = new FormData();
            newformdata.append("url", windowurl);
            newformdata.append("noncestr", dataObj.noncestr);
            newformdata.append("timestamp", dataObj.timestamp);
            AgentConfigUrl(newformdata).then((res) => {
                let data = res.data;
                wx.agentConfig({
                    timestamp: dataObj.timestamp, // 必填，生成签名的时间戳
                    nonceStr: dataObj.noncestr,
                    corpid: corpid, // 必填，企业微信的，必须与当前登录的企业一致
                    agentid: agentid, // 必填，企业微信的应用id
                    signature: data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                    jsApiList: jsApiList, //必填，传入需要使用的接口名称
                    success: function (res) {
                        console.log(res,'success')
                        flag = true;
                        resolve(flag);
                    },
                    fail: function (res) {
                        console.log(res);
                        if (res.errMsg.indexOf("function not exist") > -1) {
                            Toast.fail("版本过低请升级");
                        }
                        reject(flag);
                    },
                });
            });
        });
    }).catch(e =>{
        console.log(e);
    });
}
